import { PlanKind } from '../entity/api/organization-billing';

let env = (import.meta.env.VITE_APP_ENV ?? 'development') as
  | 'development'
  | 'staging'
  | 'testing'
  | 'production';
if (env !== 'staging' && env !== 'testing' && env !== 'production') {
  env = 'development';
}
const isE2eTest = ((import.meta.env.VITE_IS_E2E as string) ?? '').toLowerCase() === 'true';

export function getConfig() {
  const baseConfig = {
    appName: 'Writer',
    mobileBreakpoint: 768,
    bloggleAppUrl: 'http://localhost:8081',
    appDomain:
      env === 'development'
        ? ((import.meta.env.VITE_APP_DOMAIN as string) ?? 'http://localhost:8083')
        : 'http://localhost:8083',
    api:
      env === 'development'
        ? ((import.meta.env.VITE_API_URL as string) ?? 'http://localhost:8084')
        : 'http://localhost:8084',
    isE2eTest,

    gitHash: (import.meta.env.VITE_BUILD_COMMIT_HASH as string) ?? '',
    product: {
      enabledBrandTypes: ['eCommerce'] as string[],
    },

    env,
    supportEmail: 'support@blym.co',
    currency: '$',
    creditPerContentCreation: 1,
    creditPerRewrite: 0.5,
    creditPerAuditCreation: 1,
    creditPerAuditRefresh: 1,

    // third party services...
    sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string) ?? '',
    helpScoutBeaconId: 'd49183cb-cc8c-4c7a-b32e-4eca89130be5',
    clerk: {
      publishableKey: (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string) ?? '',
    },
    tipTap: {
      aiAppId: import.meta.env.VITE_TIP_TAP_AI_APP_ID as string,

      aiToken: import.meta.env.VITE_TIP_TAP_AI_TOKEN as string,
    },

    isProductAvailable:
      ((import.meta.env.VITE_IS_PRODUCT_AVAILABLE as string) ?? '').toLowerCase() === 'true',
    passwordMinimumLength: 6,
    forgotVerificationCodeLength: 6,
    signupVerificationCodeLength: 6,
    imagesFileFormat: ['.png', '.jpg', '.jpeg', '.gif', '.webp'],
    extraDocumentsFileFormat: ['.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx'],
    imagesMaxSize: 2, // in MB
    extraDocumentsMaxSize: 10,
    csvMaxSize: 100, // in MB
    trialDays: 7,
    predictedMonthlyLtv: 620,
    urlWebsitePriceComparison: 'https://www.blym.co/pricing',

    defaultCountry: 'us',
    defaultLanguage: 'en',

    metaTitleLimit: 60,
    metaDescriptionLimit: 160,
    urlSlugLimit: 60,
    surveyLink: 'https://50575mc4xd2.typeform.com/to/eQjsbBOm',
    urlHelpExportContentLink: 'https://help.blym.co/en/article/exporting-content-15xgun7/',
    urlHelpExcerpt: 'https://help.blym.co/en/article/set-up-your-brand-context-5nf4c3/#2-excerpts',
    urlHelp: 'https://help.blym.co/en/',
    urlHelpPrompt: 'https://help.blym.co/en/article/how-to-choose-your-targeted-prompt-yc7p2t/',
    supportedKeywordLanguages: [
      'en',
      'fr',
      'nl',
      'it',
      'es',
      'de',
      'sv',
      'no',
      'pt-PT',
      'pt-BR',
      'da',
      'fi',
      'pl',
      'ro',
    ],
    aiAssistantName: 'Broono',
    privacyPolicyPage: 'https://www.blym.co/privacy-policy',
    termsOfServicePage: 'https://www.blym.co/terms-of-service',
    gtmContainerId: '',
    avgSeoScore: '56',
    features: {
      subscription: {
        enabled:
          ((import.meta.env.VITE_IS_SUBSCRIPTION_ENABLED as string) ?? '').toLowerCase() === 'true',
      },
      brandFiller: {
        enabled:
          ((import.meta.env.VITE_IS_BRAND_FILLER_ENABLED as string) ?? '').toLowerCase() === 'true',
      },
      oneClickGeneration: {
        enabled:
          ((import.meta.env.VITE_IS_ONE_CLICK_GENERATION_ENABLED as string) ?? '').toLowerCase() ===
          'true',
      },
    },

    calendlyUrl: 'https://calendly.com/julien-m-blym/20-minute-demo-call',

    plans: {
      [PlanKind.Legacy]: {
        areUsersUnlimited: false,
      },
      [PlanKind.Custom]: {
        areUsersUnlimited: false,
      },
      [PlanKind.Lite]: {
        areUsersUnlimited: false,
      },
      [PlanKind.Grow]: {
        areUsersUnlimited: false,
      },
      [PlanKind.Scale]: {
        areUsersUnlimited: false,
      },
      [PlanKind.Enterprise]: {
        areUsersUnlimited: true,
      },
    },
  };

  if (env === 'staging') {
    // baseConfig.appDomain = 'https://writer-app-staging-146fad245aa9.herokuapp.com';
    // baseConfig.api = 'https://writer-api-staging-0628cf735c59.herokuapp.com';
    baseConfig.appDomain = 'https://app-staging.blym.co';
    baseConfig.api = 'https://api-staging.blym.co';
    baseConfig.bloggleAppUrl = 'https://appstagingv1.bloggle.app';
  } else if (env === 'production') {
    baseConfig.appDomain = 'https://app.blym.co';
    baseConfig.api = 'https://api.blym.co';
    baseConfig.gtmContainerId = 'GTM-TS6Z5BKL';
    baseConfig.bloggleAppUrl = 'https://app.bloggle.app';
  }

  return baseConfig;
}
